// extracted by mini-css-extract-plugin
module.exports = {"slide":"list_slide_TxTMq","slide-reverse":"list_slide-reverse_CUJi4","table":"list_table_2_hUi","marginContent":"list_marginContent_WfgVt"};